import React, { useContext, useEffect, useState } from "react";
import styles from "./MembershipSeries.module.css";
import * as XLSX from "xlsx";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { Link, useParams } from "react-router";
import { BiLoaderAlt } from "react-icons/bi";
import AuthContext from "../../../store/auth-context";
import ActiveStoreContext from "../../../store/ActiveStoreContext";
import { BASE_URL_API } from "../../../References/URLs";
import { toast } from "react-toastify";

const MembershipSeries = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    const { membershipIdentifier, activeTab } = useParams()

    const [series, setSeries] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
    const [readyToDownload, setReadyToDownload] = useState(false)
    const [isGenerating, setIsGenerating] = useState(false)

    const getMembershipSeries = async () => {
        setIsGenerating(true)
        const response = await fetch(BASE_URL_API + "getMembershipSeries",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authCtx.authIdentifier,
                    vendorIdentifier: vendorIdentifier,
                    membershipIdentifier: membershipIdentifier,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setSeries(respo?.response)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    setSeries([])
                }
            }
        }
        setIsGenerating(false)
    }

    const generateSeries = async () => {
        if (window.confirm("Are you sure that you want to generate 50 card numbers?")) {
            setIsGenerating(true)
            const response = await fetch(BASE_URL_API + "generateMembershipSeries",
                {
                    method: "POST",
                    body: JSON.stringify({
                        token: authCtx.token,
                        authIdentifier: authCtx.authIdentifier,
                        vendorIdentifier: vendorIdentifier,
                        membershipIdentifier: membershipIdentifier,
                        storeIdentifier: activeStore.storeIdentifier
                    })
                });

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo?.status === "success") {
                    toast(`Successfully generated the card numbers!`)
                    getMembershipSeries()
                } else {
                    if (respo?.message === "tokenExpired") {
                        authCtx.logout()
                    } else {

                    }
                }
            }
            setIsGenerating(false)
        }
    }


    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(series.map((num, i) => ({ SNo: i + 1, CardNumber: num?.membershipNumber, Status: num?.currentStatus })));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "MembershipCards");
        XLSX.writeFile(workbook, "MembershipCards.xlsx");
    };

    const selectRowHandler = (k, index, event) => {
        if (event.shiftKey && lastSelectedIndex !== null) {
            const start = Math.min(lastSelectedIndex, index);
            const end = Math.max(lastSelectedIndex, index);

            const range = series.slice(start, end + 1);

            // Merge old + new range without duplicates
            const merged = [...selectedData];
            range.forEach((item) => {
                if (!merged.some((sel) => sel.number === item.number)) {
                    merged.push(item);
                }
            });

            setSelectedData(merged);
        } else {
            const exists = selectedData.some((itemFind) => itemFind.number === k.number);
            if (exists) {
                setSelectedData(selectedData.filter((itemFind) => itemFind.number !== k.number));
            } else {
                setSelectedData([...selectedData, k]);
            }
            setLastSelectedIndex(index);
        }
    };

    const toggleSelectAll = () => {
        if (selectedData?.length === series?.length) {
            // All selected → clear all
            setSelectedData([]);
        } else {
            // Not all selected → select all
            setSelectedData(series);
        }
    };

    useEffect(() => {
        if (isGenerating) {
            setReadyToDownload(false)
            return;
        }
        if (selectedData?.length > 0) {
            setReadyToDownload(true)
        } else {
            setReadyToDownload(false)
        }
    }, [selectedData, isGenerating])

    useEffect(() => {
        getMembershipSeries()
    }, [])



    return (
        <div className={styles.mainWrapper}>
            <div className={styles.heading}>Membership Series Generator</div>
            {/* Input controls */}
            <div className={styles.controls}>
                <div className={styles.leftControls} >
                    <div>
                        <span>All </span>
                    </div>
                    <div>
                        {/* <button>Printed</button> */}
                    </div>
                </div>
                <div className={styles.rightControls} >
                    {isGenerating === false ?
                        <button onClick={generateSeries} className={styles.generateBtn} >Generate Now</button>
                        :
                        <button onClick={generateSeries} className={styles.generateBtn} ><BiLoaderAlt className={styles.spinner} size={16} /> Generating...</button>
                    }
                    {series.length > 0 && (
                        <button onClick={downloadExcel} disabled={!readyToDownload} className={readyToDownload === true ? styles.downloadBtn : styles.downloadDisabled} title={`Download ${selectedData?.length} in excel sheet for printing purpose.`} >Download Excel</button>
                    )}
                    {series.length > 0 && (
                        <Link to={`/memberships/sell-membership`} className={styles.secondaryButton} >Sell A Card</Link>
                    )}
                </div>

            </div>

            {/* Show table */}
            {series?.length > 0 && (
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        <div className={styles.tableHeader}>
                            <div className={styles.sn} onClick={() => toggleSelectAll()}>
                                {selectedData.length === series.length && series.length > 0 ? (
                                    <MdCheckBox size={20} />
                                ) : (
                                    <MdCheckBoxOutlineBlank size={20} />
                                )}
                            </div>

                            <div className={styles.sn} >S.No</div>
                            <div className={styles.cardNumber} >Card Number</div>
                            <div className={styles.status} >Status</div>
                            <div className={styles.status} >Generated On</div>
                            <div className={styles.soldOn} >Sold On</div>
                            <div className={styles.action}>Action</div>
                        </div>
                        <div className={styles.rowsWrapper} >
                            {series.map((item, index) => (
                                <div key={index} className={styles.eachRowWrapper} >
                                    <div className={styles.sn}
                                        onClick={(e) => selectRowHandler(item, index, e)}
                                    >
                                        {selectedData?.some((itemFind) => itemFind?.number === item?.number) === true ?
                                            <MdCheckBox size={20} />
                                            :
                                            <MdCheckBoxOutlineBlank size={20} />
                                        }
                                    </div>
                                    <div className={styles.sn} >{index + 1}</div>
                                    <div className={styles.cardNumber} >
                                        <span className={styles.cn} >{item?.membershipNumber}</span>
                                    </div>
                                    <div className={styles.status} >{item?.currentStatus}</div>
                                    <div className={styles.status} >{item?.createdOn}</div>
                                    <div className={styles.soldOn} >{item?.soldOn}</div>
                                    <div className={styles.action}>
                                        <button className={styles.disableBtn} >Disable</button>
                                        <Link className={styles.sellBtn} to={`/membership/sell/`} >Sell</Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </table>
                </div>
            )}
        </div>
    );
};

export default MembershipSeries;
